/**
 * The colour a tag is drawn in.
 *
 * A tag's colour is optional in the editor. Without one it is dark gray
 * everywhere, instead of the badge's default in one place and something else
 * in the next -- which is what five separately written fallbacks had become.
 * A CSS variable rather than a token, because two of the callers set inline
 * `style`, where tokens are not resolved.
 */
export const DEFAULT_TAG_COLOR = "var(--chakra-colors-gray-700)";

export function tagColor(color: string | null): string {
  return color ?? DEFAULT_TAG_COLOR;
}
